<template>
  <div class="search-name center-align m-b">
    <div class="col-s12">
      <label for="name">Saisir le libellé du produit</label>
      <input type="text" id="name" v-model="name" @keyup.enter="$emit('search', null, name)">
    </div>
    <button
      @click="$emit('search', null, name)"
      class="btn waves-effect waves-light btn-brico m-t"
      v-bind:class="{ disabled: loading }"
    >
      Rechercher
      <i class="material-icons right">send</i>
    </button>
  </div>
</template>

<script>
export default {
  props: ["loading"],
  data() {
    return {
      name: null
    };
  }
};
</script>

<style scoped>
input[type="text"]::-webkit-outer-spin-button,
input[type="text"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="text"] {
  -moz-appearance: textfield;
  text-align: center;
  height: 35px !important;
  float: left;
  width: 100%;
  padding: 0 !important;
  margin: 0 !important;
  border: 2px solid black !important;
  box-sizing: inherit !important;
}
</style>
